<mat-card appearance="outlined" class="sg-panel ai-notes" data-testid="ai-notes">
  <h2 class="section-title">Notes for AI</h2>
  <div class="ai-notes__toolbar">
    <p class="ai-notes__hint">
      Only you see your notes here. Once approved, they help improve future AI responses of that
      kind.
    </p>
    <button
      type="button"
      class="ai-notes__btn"
      data-testid="ai-note-add"
      [disabled]="!responses().length"
      (click)="openAdd()"
    >
      <app-icon name="plus" [size]="16" /> Add a note
    </button>
  </div>
  @if (!responses().length) {
    <p class="ai-notes__hint" data-testid="ai-note-none">
      There's no AI response on this file to comment on yet.
    </p>
  }
  @if (error(); as message) {
    <p class="ai-notes__hint" role="alert">{{ message }}</p>
  }
  <button type="button" class="ai-notes__row" data-testid="ai-notes-open" (click)="openList()">
    <app-icon name="chevron-right" [size]="16" />
    <app-icon name="sparkles" [size]="16" class="ai-notes__kind" />
    <span class="ai-notes__text">
      <span class="ai-notes__name">Your notes for the AI</span>
      <span class="ai-notes__hint">
        @if (latest(); as note) {
          {{ notes().length }} · {{ note.at | date: 'd MMM y' }}
        } @else {
          Nothing added yet
        }
      </span>
    </span>
    <app-icon name="lock" [size]="14" class="ai-notes__kind" />
  </button>
</mat-card>
